import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { LiaSave } from "react-icons/lia";
import { PiUpload } from "react-icons/pi";
import * as Yup from "yup";
import { ConfigProvider, message, Select, Upload } from "antd";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { GET_ADS } from "../../Store/Type";
import "../../App.css";
import { toast } from "react-toastify";
import { DatePicker, Pagination, Tooltip } from "antd";

import {
  GetAdsById,
  GetAdsData,
  GetMobileAds,
  SubmitAdsData,
  SubmitAdsMobile,
  GetMbleAdsById,
  GetClientById,
  GetClientList,
} from "../../Api/Ads/Ads";
import dayjs from "dayjs";
import {Spin} from "antd";
import AdsListView from "./AdsListView";
import { RxCross2 } from "react-icons/rx";
const {Option}=Select

const validationSchema = Yup.object()
  .shape({
    ad_title: Yup.string()
      .min(1, "Title must be greater than 1 character")
      .max(50, "Title should not be greater than 50 characters")
      .required("Title is required"),
    client_details: Yup.string().required("Client Name is required"),
    // usage_per_day: Yup.string()
    //   .min(1, "minimum usage is 1")
    //   .max(100, "Max usage is 100")
    //   .required("Usage is required")
    //   .matches(/^[0-9]+$/, "Only numbers are allowed"),
    usage_per_day: Yup.string()
      .required("Display Limit is required")
      .matches(/^[0-9]+$/, "Only numbers are allowed")
      .test("is-valid-range", "Usage must be between 1 and 100", (value) => {
        const num = Number(value);
        return num >= 1 && num <= 100;
      }),
       hours: Yup.string().required("Hours and Duration is required"),
    status: Yup.string().required("Status is required"),
    // start_date: Yup.string().required("Start Date is required"),
    // end_date: Yup.string().required("End Date is required"),
    start_date: Yup.string(),
    end_date: Yup.string(),
    file:Yup.string() .required("File is empty"),
    ad_description: Yup.string()
      .required("Description is required")
      .min(4, "Description must be greater than 4 characters")
      .max(150, "Description should not be greater than 150 characters"),
page_name: Yup.string().required("Please select the Page")
      .test("required", "A file is required", function (value) {
        const { isEdit } = this.options.context;
        if (!isEdit && !value) {
          return false;
        }
        return true;
      })
      .test("file_size", "File size is too large", function (value) {
        if (value && value.size > 20500000) {
          // 20MB updated
          return false;
        }
        return true;
      })
      .test("file_type", "Unsupported File Format", function (value) {
        if (typeof value === "string") {
          // If value is a string (file path), skip file type validation
          return true;
        }
        if (value) {
          const validTypes = [
            "image/gif",
            "video/mp4",
            "image/jpeg",
            "image/jpg",
            "image/png",
          ];
          const isValidType = validTypes.includes(value.type);
          const isInvalidImageType = [
            "video/mp4",
            // "image/jpeg",
            // "image/jpg",
            // "image/png",
          ].includes(value.type);
          return isValidType || !isInvalidImageType;
        }
        return false;
      }),

    // duration: Yup.string().required("Duration is required")
  })
  // .test(
  //   "both-required",
  //   "Start Date and End Date are required",
  //   function (value) {
  //     const { start_date, end_date } = value || {};
  //     if (!start_date && !end_date) {
  //       return this.createError({
  //         path: "start_date",
  //         message: "Start Date and End Date are required",
  //       });
  //     }
  //     return true;
  //   }
  // );
  .test(
    "both-required",
    "Start Date and End Date are required",
    function (value) {
      const { start_date, end_date } = value || {};

      // Check if both start_date and end_date are provided
      if (!start_date || !end_date) {
        return this.createError({
          path: "start_date",
          message: "Start Date and End Date are required",
        });
      }

      // Check if end_date is not more than 30 days after start_date
      const startDate = new Date(start_date);
      const endDate = new Date(end_date);

      // Ensure endDate is not greater than 30 days after startDate
      const maxEndDate = new Date(startDate);
      maxEndDate.setDate(startDate.getDate() + 90);

      if (endDate > maxEndDate) {
        return this.createError({
          path: "end_date",
          message: "End Date should be within 90 days from Start Date",
        });
      }
     
      

      return true; // If all validations pass
    }
    
  );

const Ad_Advertisement = ({
  setIsModalOpen,
  updatedata,
  adsdata,
  setAdsData,
  SetUpdateData,
  tabType,
  setLoad,
  loader,
  
  // ad_id,
  // SetAdId
  // clientdetail,
  // setClientDetail,
}) => {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const { RangePicker } = DatePicker;
  const { Dragger } = Upload;
  const [advalues, setAdValues] = useState();
  const dispatch = useDispatch();
  const [fileName, setFileName] = useState("");
  const [fileImage, setFileImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [showScreen, SetShowScreen] = useState(true);
  console.log(showScreen, "show_screen");
  const [hours, setHours] = useState("");
  const [duration, setDuration] = useState("");
  console.log(hours,duration ,"hours&dureation")
 

  
  const get_clientList = useSelector((state) => state.crm.ads_client_list);
  const [ad_id, SetAdId] = useState(null);
  const [draggerImage, setDraggerImage] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

const [required, setRequired] = useState(false);
console.log(required, "required_value");
  console.log(selectedOption, "selected_Options");
  const wrapperRef = useRef(null)

  const hourOptions = [
  { value: '', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-gray-500 cursor-not-allowed">Select Time Duration</div>),disabled:true },
  { value: 'regular_8-10', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">(06:00 - 11:00) - Regular Hours</div>)},
  { value: 'regular_12-14', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">(11:00 - 18:00) - Regular Hours</div>)},
  { value: 'peak_18-22', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">(18:00 - 23:00) - Peak Hours</div>)},
  { value: 'regular_14-17', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">(23:00 - 06:00) - Regular Hours</div>)},
];
const mobilepageOptions=[
  { value: '', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-gray-500 cursor-not-allowed">Select Page </div>),disabled:true },
  { value:'Trip',label:(<div className="text-[1vw] px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">Home & Trip Page</div>)},
  { value:'Filter',label:(<div className="text-[1vw] px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">Filter Page</div>)},
] 
const webpageOptions=[
  { value: '', label: (<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-gray-500 cursor-not-allowed">Select Page</div>),disabled:true },
  { value:'Trip',label:(<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">Home & Trip Page</div>)},
  { value:'Dashboard',label:(<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">Ticket Page</div>)},
  { value:'Filter',label:(<div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">Filter Page</div>)},
] 

  // const selectDurationChange = (event) => {

  //   const value = event.target.value;
  
  //   console.log("Selected value:", value);

  //   setSelectedOption(value);
  //   setFieldValue("hours",value)

  //   if (value.includes("peak")) {
      
  //     setHours("peak");
  //     setDuration(value.split("_")[1]);
  //     setRequired(false)
  //   } else if (value.includes("regular")) {
  //     setHours("regular");
  //     setDuration(value.split("_")[1]);
  //     setRequired(false)
  //   } else {
  //     setHours("");
  //     setDuration("");
  //     setRequired(true);
  //   }
   
  // };

  const splithours = hours.split("_")[0];


  console.log(adsdata, "This is the update data for ads");
  console.log(tabType, "tab__type");
  const props = {
    name: "file",
    multiple: false,
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    fileList: fileList, // Manage the file list manually
    onChange(info) {
      const { status, name } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
        console.log(info.file, "filetesting");
      }
      if (status === "done") {
        message.success(`${name} file uploaded successfully.`);
        setFileList([info.file]); // Set file list to contain only the last uploaded file
      } else if (status === "error") {
        message.error(`${name} file upload failed.`);
      }
    },
    beforeUpload(file) {
      setFileList([file]);
      return true;
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  console.log(adsdata?.ads_status, "durationnnnnnn");

  // const fetchClientDetails = async () => {
  //   try {
  //     const response = await GetClientById(
  //       ClientId,
  //       setclientId,
  //       setClientDetail
  //     );
  //     console.log(response, "datadata");
  //     setClientDetail(response?.data[0]);
  //   } catch (error) {
  //     console.error("Error fetching additional user data", error);
  //   }
  // };

  useEffect(() => {
    console.log(get_clientList, "Client name List");
    GetClientList(dispatch);
  }, []);

  const fetchGetAds = async () => {
    if (tabType == "Web") {
      try {
        const data = await GetAdsById(updatedata, SetUpdateData, setAdsData);
        console.log(updatedata, "datadata1");
        SetAdId(updatedata);
        setLoad(true)
        setAdsData(data);
        console.log(data, "datadata");
        setFileImage(data.ad_video);
      } catch (error) {
        console.error("Error fetching additional user data", error);
      }
    } else {
      try {
        const data = await GetMbleAdsById(
          updatedata,
          SetUpdateData,
          setAdsData
        );
        console.log(data, "datadata");
        SetAdId(updatedata);
        setLoad(true);
        setAdsData(data);
        setFileImage(data.mobad_vdo);
      } catch (error) {
        console.error("Error fetching additional user data", error);
      }
    }
  };

  useEffect(() => {

      fetchGetAds();
    
  },[]);


useEffect(() => {
  if (adsdata) {
    const newHours = adsdata.hours || "";
    const newDuration = adsdata.duration || "";
    const newSelected = `${newHours}_${newDuration}`;

    setSelectedOption(newSelected);
    setHours(newHours);
    setDuration(newDuration);
  }
}, [adsdata])

const getInitialHours = (adsdata) => {
  const hours = adsdata?.hours ?? "";
  const duration = adsdata?.duration ?? "";

  if (!hours && !duration) return "";
  return `${hours}_${duration}`;
};


 

  const handleSubmit = async (values) => { 


    
    console.log(ad_id, "fulllist");
    console.log(updatedata, "datadata2");
    console.log(values, "values111111", duration, "duration", hours, "hours");

// Check if duration or hours are missing or invalid
  if (!duration || !hours || duration.trim() === "" || hours.trim() === "") {
    setRequired(true);
    console.log("Missing duration or hours");
    return; // Stop submission
  } else {
    setRequired(false);
  }


      if (tabType == "Web") {
        try {
          const data = await SubmitAdsData(
            values,
            ad_id,
            duration,
            hours,
            adsdata,
            dispatch,
          );
          console.log(
            values,
            "vallllllllll",
            ad_id,
            "add handle submit values"
          );
          //  await new Promise(resolve => setTimeout(resolve, 100));
          //  console.log('Submitted!');

          setLoad(true)
          setIsModalOpen(false);
          toast.success(data?.message);
          GetAdsData(dispatch);
          console.log(values, "values");
          // setDuration("");
          // setHours("Select Hours");
        } catch (error) {
          console.error("Error uploading data", error);
        }


      } else {
        try {
          const data = await SubmitAdsMobile(
            values,
            ad_id,
            duration,
            hours,
            adsdata,
            dispatch
          );
        
          setLoad(true);
          setIsModalOpen(false);
          toast.success(data?.message);
          GetMobileAds(dispatch);
          console.log(data, "mobile addddddddds");
        } catch (error) {
          console.error("Error uploading data", error);
        }


      }
   
  };

  // const typeid = sessionStorage.getItem("type_id");
  const typeid = sessionStorage.getItem("type_id");

  const getStatusOptions = () => {
    if (typeid == "PRO101") {
      return [
        // { label: "Select Status", value: "" },
        { label: "Draft", value: "Draft" },
        { label: "Active", value: "Active" },
      ];
    } else if (typeid == "EMP101") {
      return [
        // { label: "Select Status", value: "" },
        { label: "Draft", value: "Draft" },
        { label: "Requested", value: "Requested" },
      ];
    } else if (typeid == "PROEMP101") {
      return [
        // { label: "Select Status", value: "" },
        { label: "Draft", value: "Draft" },
        { label: "Requested", value: "Requested" },
      ];
    } else {
      return [{ label: "Select Status", value: "" }];
    }
  };

  const options = getStatusOptions();

  // const handleHoursChange = (event) => {
  //   const value = event.target.value;
  //   setHours(value);
  //   if (value === "peak") {
  //     setDuration("18 - 22");
  //   } else {
  //     setDuration("");
  //   }
  // };

  // const handleDurationChange = (event) => {
  //   setDuration(event.target.value);
  // };



  // useEffect(()=>{
  //  if (!selectedOption) {
  //     setRequired(true);
  //   } else {
  //     setRequired(false);
  //   }
  // },[selectedOption])

  console.log(hours, duration, "durationduration");
  const [minExpiryDate, setMinExpiryDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  return (
    <div className="">
      <Formik
        initialValues={{
          ad_title:
            tabType == "Web" && adsdata
              ? adsdata?.ad_title
              : adsdata?.mobad_title || "",
          client_details: adsdata ? adsdata?.client_details : "",
          status:  adsdata?.ads_status || "",
          start_date: adsdata?.start_date
            ? dayjs(adsdata?.start_date).format("YYYY-MM-DD")
            : "",
          end_date: adsdata?.end_date
            ? dayjs(adsdata?.end_date).format("YYYY-MM-DD")
            : "",
          ad_description:
            tabType == "Web" && adsdata
              ? adsdata?.ad_description
              : adsdata?.mobad_description || "",
          usage_per_day: adsdata?.usage_per_day || "",
          page_name:
            tabType === "Web"
              ? adsdata.page_name || ""
              : adsdata?.page_name || "",
          file:
            tabType == "Web" && adsdata
              ? adsdata?.ad_video
              : adsdata?.mobad_vdo || "",
          tbs_client_id: adsdata?.tbs_client_id || "",
          ad_file_type:
            tabType == "Web" && adsdata
              ? adsdata?.ad_file_type
              : adsdata?.mobad_file_type || "",
          ad_file_size:
            tabType == "Web" && adsdata
              ? adsdata?.ad_file_size
              : adsdata?.mobad_file_size || "",
        hours: getInitialHours(adsdata)||"",
        
        }}

        
        


        validationSchema={validationSchema}
        
onSubmit={(values) => {
    console.log("Form submitted:", values);
    handleSubmit(values);
  }}

        enableReinitialize={true}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          values,
          errors,
          touched,
          isSubmitting
          
        }) => (
          <Form onSubmit={handleSubmit} className="relative" >
            {
              isSubmitting&&(<div className="absolute top-[30vh] left-[20vw] flex justify-center items-center  z-10">
            <Spin size="large" />
          </div>)
            }
            {/* {showScreen == true ? ( */}
            <div className="Add-Section text-[#1f487c]">
              <div className="flex flex-col">
                <div className="flex justify-between mr-[3.5vw]">
                  <div className="text-[1.2vw] text-[#1F4B7F] font-bold pt-[0.5vw]">
                    {ad_id ? "UPDATE" : "CREATE"} ADVERTISEMENT
                  </div>
                  {/* <button
                    onClick={() => {
                      SetShowScreen(false);
                      setHours(adsdata ? adsdata.hours : "");
                      setDuration(adsdata ? adsdata.duration : "");
                    }}
                    className="flex bg-[#1F4B7F] mt-[0.2vw] px-[0.8vw] gap-[0.5vw] py-[0.3vw] rounded-[0.7vw] items-center justify-center"
                    type="button"
                  >
                    <span className="text-white text-[1.2vw]"> Next </span>
                    <span>
                      <TbPlayerTrackNextFilled color="white" size={"1.5vw"} />
                    </span>
                  </button> */}
                <div className="flex flex-row items-center space-x-6 -mr-[3.2vw]">
  <button
    className={`flex bg-[#1F4B7F] px-[0.8vw] gap-[0.5vw] py-[0.3vw] rounded-[0.7vw] items-center justify-center h-[2.5vw] ${isSubmitting ? "cursor-not-allowed" : "cursor-pointer"}`}
    type="submit"
    disabled={isSubmitting}
  >
    <span>
      <LiaSave color="white" size="1.5vw" />
    </span>
    <span className="text-white text-[0.9vw]">
      {ad_id ? "SAVE" : "CREATE"} ADS
    </span>
  </button>

  <button
    className="bg-[#1F4B7F] cursor-pointer w-[2.5vw] h-[2.5vw] items-center justify-center flex rounded-full ml-[0.5vw]"
    onClick={() => setIsModalOpen(false)}
  >
    <RxCross2
      className="cursor-pointer"
      color="white"
      size={"1.5vw"}
    />
  </button>
</div>

                </div>
                

                <div className=" flex flex-col gap-[1.2vw] mt-[0.5vw]">
                  <div className="grid grid-cols-2 gap-x-[2vw]">
                    {/* client title */}

    <div className="relative">
      <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
        Client Details
        <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
      </label>

      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionSelectedColor: "white",
              optionSelectedBg: "#D3D3D3",
              optionHeight: "2",
            },
          },
        }}
      >
        <Select
          placeholder="Select Client"
          value={values.client_details || undefined}
          onChange={(value) => {
            setFieldValue('client_details', value);
            const selectedClient = get_clientList?.find(
              (item) => item?.owner_name === value
            );
            setFieldValue('tbs_client_id', selectedClient?.tbs_client_id);
            sessionStorage.setItem('client_details', value);
          }}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
          dropdownStyle={{ width: '23vw', left: '26vw' }}
          options={[
            {
              value: "",
                    label: (
                      <div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#a9a9a9] cursor-not-allowed">
                        Select Client
                      </div>
                    ),
                    disabled: true,
            },
            ...get_clientList?.map((client)=>({
              key:client.tbs_client_id,
              value:client?.owner_name,
              label:(
                 <div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">
                 {client?.owner_name}
              </div>
              )
            }))
          ]}
          className="custom-select border-r-[0.175vw] mt-[0.5vw] border-l-[0.05vw] border-t-[0.05vw] border-b-[0.175vw] placeholder-[#1F487C] border-[#1F487C] 
            text-[#1F487C] text-[1vw] h-[2.7vw] w-[100%] rounded-[0.75vw] outline-none p-[0.5vw]"
        >
          {/* {get_clientList?.map((client) => (
            <Select.Option key={client?.tbs_client_id} value={client?.owner_name}>
              <div className="text-[1vw] px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">
                {client?.owner_name}
              </div>
            </Select.Option>
          ))} */}
        </Select>
      </ConfigProvider>

      <ErrorMessage
        name="client_details"
        component="div"
        className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
      />
    </div>

                    {/* ads title */}
                    <div className="relative">
                      <label className="text-[1.1vw] font-medium text-[#1f487c]">
                        Ads Title
                        <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                          *
                        </span>
                      </label>
                      <Field
                        type="text"
                        name="ad_title"
                        placeholder="Enter Title"
                        value={values?.ad_title}
                        onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
                          }}
                        className="placeholder-[#1F487C] border-r-[0.175vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.175vw] placeholder:text-[1vw] border-[#1F487C]
                     text-[#1F487C] text-[1vw] h-[2.7vw] w-[100%] rounded-[0.75vw] outline-none px-[1vw]"
                      />
                      <ErrorMessage
                        name="ad_title"
                        component="div"
                        className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                      />
                    </div>
                  </div>
                  {/* <div className="relative">
                      <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
                        Start Date
                      </label>
                      <Field
                        type="date"
                        name="start_date"
                        placeholder="Start Date"
                        value={values.start_date}
                        // onChange={(e) => {
                        //   const selectedStartDate = e.target.value;
                        //   handleChange(e);
                        //   sessionStorage.setItem("start_date", selectedStartDate);

                        //   // Update the minimum end date to the selected start date
                        //   setMinExpiryDate(selectedStartDate);
                        // }}
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          const selectedStartDate = e.target.value;
                          handleChange(e);
                          sessionStorage.setItem("start_date", selectedStartDate);
                          // Update the minimum expiry date
                          setMinExpiryDate(selectedStartDate);
                        }}
                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                      text-[#1F487C] text-[1vw] h-[2.7vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                      />
                      <ErrorMessage
                        name="start_date"
                        component="div"
                        className="text-red-500 text-[0.8vw]"
                      />
                    </div>
                    <div className="relative">
                      <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
                        End Date
                      </label>
                      <Field
                        type="date"
                        name="end_date"
                        placeholder="End Date"
                        min={minExpiryDate}
                        value={values.end_date}
                        onChange={(e) => {
                          handleChange(e);
                          sessionStorage.setItem("end_date", e.target.value);
                        }}
                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                      text-[#1F487C] text-[1vw] h-[2.7vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                      />
                      <ErrorMessage
                        name="end_date"
                        component="div"
                        className="text-red-500 text-[0.8vw]"
                      />
                    </div> */}

                  <div className="grid grid-cols-2 gap-x-[2vw]">
                    <div className="relative flex flex-col ">
                      <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
                        Ads Description
                        <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                          *
                        </span>
                      </label>
                      <Field
                        as="textarea"
                        
                        name="ad_description"
                        placeholder="Enter Description"
                        // rows="1"
                       onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
                          }}
                        value={values?.ad_description}
                         rows="3"
                  cols="50"
                  style={{ resize: "none", lineHeight: "2.6vw" }} 
                  className="border-r-[0.2vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.175vw] placeholder-[#1F487C] border-[#1F487C] text-[#1F487C] text-[1vw] h-[2.9vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] "
                />
                      <ErrorMessage
                        name="ad_description"
                        component="div"
                        className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                      />
                    </div>
                    <div className="relative flex flex-col">
                      <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
                        Duration
                        <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                          *
                        </span>
                      </label>
                      <Field name="date_range">
                        {({ field }) => (
                          <ConfigProvider
                            theme={{
                              token: {
                                fontSize: 13,
                                lineHeight: 0,
                                colorPrimary: "#1F487C",
                              },
                              components: {
                                DatePicker: {
                                  cellWidth: 21,
                                  cellHeight: 20,
                                },
                              },
                            }}
                          >
                            <RangePicker
                              allowClear={true}
                              autoFocus={false}
                              inputReadOnly={true}
                              onChange={(dates) => {
                                const [startDate, endDate] = dates || [
                                  null,
                                  null,
                                ];
                                setFieldValue(
                                  "start_date",
                                  startDate
                                    ? startDate.format("YYYY-MM-DD")
                                    : ""
                                );
                                setFieldValue(
                                  "end_date",
                                  endDate ? endDate.format("YYYY-MM-DD") : ""
                                );
                              }}
                              value={[
                                values.start_date
                                  ? dayjs(values.start_date)
                                  : null,
                                values.end_date ? dayjs(values.end_date) : null,
                              ]}
                              className="ads-date border-r-[0.175vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.175vw] placeholder-blue border-[#1F487C]
text-[#1F487C] text-[0.8vw] h-[2.7vw] w-[100%] rounded-[0.75vw] outline-none px-[1vw] placeholder-[#1F487C]"
                              disabledDate={(current) =>
                                current < dayjs().startOf("day")
                              }
                            />
                          </ConfigProvider>
                        )}
                      </Field>
                      <ErrorMessage
                        name="start_date"
                        component="div"
                        className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                      />
                      <ErrorMessage
                        name="end_date"
                        component="div"
                        className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] "
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-x-[2vw]">
                    <div className="relative">
                      <label className="text-[1.1vw] font-medium text-[#1f487c]">
                        Display Limit / Day
                        <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                          *
                        </span>
                      </label>
                      <Field
                        type="text"
                        name="usage_per_day"
                        placeholder="Enter Display Limit / Day"
                        value={values?.usage_per_day}
                        onChange={handleChange}
                        className=" placeholder-[#1F487C] border-r-[0.175vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.175vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[2.7vw] w-[100%] rounded-[0.75vw] outline-none px-[1vw]"
                      />
                      <ErrorMessage
                        name="usage_per_day"
                        component="div"
                        className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                      />
                    </div>
                    {/* <div className="relative">
                      <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
                        Ads Display Page
                      </label>
                      <Field
                        as="select"
                        name="page_name"
                        value={values.page_name}
                        onChange={(e) => {
                          handleChange(e);
                          sessionStorage.setItem("page_name", e.target.value);
                        }}

                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                   text-[#1F487C] text-[1vw] h-[2.7vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                      >
                        <option label="Select Page" value="" className="" />
                        <option label="Home" value="Home" className="" />
                        <option
                          label="Dashboard"
                          value="Dashboard"
                          className=""
                        />
                        <option label="Filter" value="Filter" className="" />
                        <option label="Other" value="Other" className="" />
                      </Field>
                      <ErrorMessage
                        name="page_name"
                        component="div"
                        className="text-red-500 text-[0.8vw] absolute bottom-[1.2vw]"
                      />
                    </div> */}

      <div className="relative">
        <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
          Hours
          <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
        </label>
        <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                        
                          optionSelectedColor: "white",
                          optionSelectedBg: "#D3D3D3",
                          optionHeight: "2",
                        },
                      },
                    }}
                  >

        <Select
  value={values.hours || undefined} // Ensures placeholder shows when no value
  className="custom-select mt-[0.5vw] bg-white outline-none w-full h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.15vw] border-b-[0.15vw] placeholder-[#1F487C] placeholder:text-[1vw]"
  placeholder="Select Time Duration"
  options={hourOptions}
  onChange={(value) => {
    setFieldValue("hours", value);
        if (value.includes("peak")) {
              setHours("peak");
              setDuration(value.split("_")[1]);
              setRequired(false);
            } else if (value.includes("regular")) {
              setHours("regular");
              setDuration(value.split("_")[1]);
              setRequired(false);
            } else {
              setHours("");
              setDuration("");
              setRequired(true);
            }
          }}
          style={{
          padding: 1,
        }}
        />
        </ConfigProvider>

        <ErrorMessage
                          name="hours"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                        />
      </div>

                  </div>

                  <div className="grid grid-cols-2 gap-x-[2vw]">
                    {tabType == "Web" ? (
                      <div className="relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
                          Ads Display Page
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                   <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                        
                          optionSelectedColor: "white",
                          optionSelectedBg: "#D3D3D3",
                          optionHeight: "2",
                        },
                      },
                    }}
                  >
                        <Select
                          name="page_name"
                          placeholder="Select Page"
                          value={values.page_name || undefined}
                          onChange={(value) => {
    setFieldValue("page_name", value);
                          }}
                          options={webpageOptions}
                          getPopupContainer={() => wrapperRef.current}
        popupMatchSelectWidth={false}
        dropdownAlign={{ overflow: { adjustY: false } }}
                           dropdownStyle={{
          transition:'none',
          position: 'absolute',
          top: '57%',
          marginTop: '4.5vw',
          left:'26.5vw',
          width: '22%',
          zIndex: 1000,
          
          
        }}
                          className="custom-select mt-[0.5vw] bg-white outline-none w-full h-[3vw] p-[0.5vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.15vw] border-b-[0.15vw] placeholder-[#1F487C] placeholder:text-[1vw]"
                        >
                          </Select>
                        </ConfigProvider>
                        <ErrorMessage
                          name="page_name"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                        />
                      </div>
                    ) : (
                      <div className="relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
                          Ads Display Page
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                         <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                        
                          optionSelectedColor: "white",
                          optionSelectedBg: "#D3D3D3",
                          optionHeight: "2",
                        },
                      },
                    }}
                  >
                        <Select
                          name="page_name"
                          placeholder="Select Page"
                          value={values.page_name || undefined}
                          onChange={(value) => {
    setFieldValue("page_name", value);
                          }}
                          options={mobilepageOptions}
                          className="custom-select mt-[0.5vw] bg-white outline-none w-full h-[3vw] px-[0.5vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.15vw] border-b-[0.15vw] placeholder-[#1F487C] placeholder:text-[1vw]"
                        >
                          </Select>
                        </ConfigProvider>
                        <ErrorMessage
                          name="page_name"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                        />
                      </div>
                    )}

<div className="relative">
  <label className="text-[#1F4B7F] text-[1.1vw] font-medium">
    Ads Status
    <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
  </label>

  <Field name="status">
    {({ field, form }) => (
      <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                          // optionActiveBg: "gray",
                          optionSelectedColor: "white",
                          optionSelectedBg: "#D3D3D3",
                          optionHeight: "2",
                          color:'#1F4B7F'
                        },
                      },
                    }}
                  >
      <Select
        {...field}
        value={form.values.status || undefined}
        disabled={form.values.status === "Under Review"}
        onChange={(value) => {
          form.setFieldValue("status", value);
          sessionStorage.setItem("status", value);
        }}
        className="custom-select mt-[0.5vw] bg-white outline-none w-full h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.15vw] border-b-[0.15vw] placeholder-[#1F487C]"
                placeholder="Select Status"
        // dropdownStyle={{ fontSize: "1vw", color: "#1F487C" }}
        style={{
          padding: 1,
        }}
        options={[
          {
                    value: "",
                    label: (
                      <div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#a9a9a9] cursor-not-allowed">
                        Select Status
                      </div>
                    ),
                    disabled: true,
                  },
          ...options?.map((option)=>({
            key:option.value,
            value:option.value,
            label:(
              <div className="text-[1vw]  px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">
                {option.label}
              </div>
            )
          }))
        ]}
      >
        {/* {options?.map((option) => (
          <Option key={option.value} value={option.value} className="flex items-center text-[1vw] gap-x-[0.5vw] px-[0.2vw] pb-[0.1vw] text-[#1F4B7F]">
            {option.label}
          </Option>
        ))} */}
      </Select>
      </ConfigProvider>
    )}
  </Field>

  <ErrorMessage
    name="status"
    component="div"
    className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
  />
</div>

                  </div>
                </div>
                <div className="col-span-1 flex flex-col mt-[0.75vw]">
                  <div className="w-full mb-[0.5vw] text-[1.1vw] font-medium text-[#1f487c] relative">
                    Upload Ads
                    <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                      *
                    </span>
                    <p className="text-[#1F4B7F] text-[0.8vw] absolute bottom-0 right-[0.2vw] ">
                      {`(${"File Format: JPG, JPEG, PNG, GIF"})`}
                    </p>
                  </div>
                  <Field name="file">
                    {({ field }) => (
                      <>
                        <Dragger
                          accept=".gif, .png, .jpeg, .jpg"
                          multiple={false}
                          height={"6vw"}
                          beforeUpload={(file) => {
                            setFieldValue("file", file);
                            console.log(file, "fileee");
                            setFileName(file.name);
                            setFieldValue("ad_file_type", file.type);
                            setFieldValue("ad_file_size", file.size);
                            const imgurl = URL.createObjectURL(file);
                            setFileImage(imgurl);
                            return false;
                          }}
                          showUploadList={false}
                          className="border-l-[0.1vw] border-r-[0.175vw] border-t-[0.1vw] border-b-[0.175vw]  rounded-[0.68vw] border-[#1F487C]  relative"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                         
                          }}
                          onChange={(e) => {
                            setFieldValue("file", e.file);
                            console.log(e.file, "on change file");
                            handleChange({
                              target: { name: "file", value: e.file },
                            });
                            setDraggerImage(true);
                          }}
                        >
                          <label className="flex items-center justify-center ">
                            <p className="text-[#1F4B7F] text-[1.1vw] pr-[1vw]">
                              Drag and Drop
                            </p>
                            <PiUpload color="#1F4B7F" size={"1.2vw"} />
                          </label>
                          <div
                            className="absolute  rounded-lg  w-full h-full top-0 left-0 z-0 overflow-hidden"
                            style={{
                         backgroundImage: `url(${
  tabType === "Web"
    ? draggerImage === false
      ? `${apiImgUrl}${adsdata?.ad_video || ''}`
      : `${fileImage}`
    : draggerImage === false
    ? `${apiImgUrl}${adsdata?.mobad_vdo || ''}`
    : `${fileImage}`
})`,

                              backgroundSize: "cover",
                              backgroundPosition: "center",
                             
                              opacity: "30%",
                              
                            }}
                          ></div>
                        </Dragger>
                      </>
                    )}
                  </Field>

                  {/* {fileName && (
                    <p className="text-[#1F4B7F] text-[0.8vw] absolute bottom-0 ">
                      {fileName}
                    </p>
                  )}
                  {errors.file && touched.file && (
                    <div className="text-red-500 text-[0.8vw] absolute bottom-0">
                      {errors.file}
                    </div>
                  )} */}
                  {/* {fileName && !errors.file ? (
                    <p className="text-[#1F4B7F] text-[0.8vw] absolute bottom-0 ">
                      {fileName}
                    </p>
                  ) : (
                    <ErrorMessage
                      name="file"
                      component="div"
                      className="text-red-500 text-[0.8vw] absolute bottom-0"
                    />
                  )} */}
                  {errors.file && (
                    <ErrorMessage
                      name="file"
                      component="div"
                      className={
                        "text-red-500 text-[0.8vw] absolute bottom-1 bg-white  z-20 -mb-[1.5vw]"
                      }
                    />
                  )}
                  {/* {fileName && (
                    <p
                      className={
                        errors.file === "File is empty"
                          ? "text-[#1F4B7F] text-[0.8vw] mt-2 absolute bottom-0 bg-white w-[80%] z-30"
                          : "text-[#1F4B7F] text-[0.8vw] mt-2 absolute bottom-0 bg-white w-[80%] z-10"
                      }
                    >
                      {fileName}
                    </p>
                  )} */}
                  {fileName && !errors.file && (
                    <p
                      className={
                        "text-[#1F4B7F] text-[0.8vw] -bottom-[1.3vw] absolute  w-[80%] z-50"
                      }
                    >
                      {fileName}
                    </p>
                  )}
                </div>
                <div className="flex flex-col"></div>
              </div>
            </div>
            {/* ) : ( */}
            <div>
              <div className="flex justify-between pr-[3vw]">
                {/* <button
                  onClick={() => SetShowScreen(true)}
                  className="flex bg-[#1F4B7F] mt-[0.2vw] px-[0.8vw] gap-[0.5vw] py-[0.3vw] rounded-[0.7vw] items-center justify-start"
                >
                  <span>
                    <HiMiniBackward color="white" size="1.5vw" />
                  </span>
                  <span className="text-white text-[1vw]">back</span>
                </button> */}
              </div>
              {/* <div className="grid grid-cols-2 gap-[1vw]">
                    <div className="mb-4">
                      <label
                        htmlFor="hours"
                        className="w-full mb-[0.5vw] text-[1.1vw] font-semibold text-[#1f487c]"
                      >
                        Hours
                      </label>
                      <Field
                        as="select"
                        id="hours"
                        name="hours"
                        value={hours}
                        // defaultvalue={{
                        //   label: "test",
                        //   value: "test",
                        // }}
                        onChange={handleHoursChange}
                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                     text-[#1F487C] text-[1vw] h-[2.7vw] w-full rounded-[0.5vw] outline-none px-[1vw]"
                      >
                        <option value="" disabled>
                          Select Hours
                        </option>
                        <option value="peak">Peak Hour</option>
                        <option value="regular">Regular Hour</option>
                      </Field>
                      <ErrorMessage
                        name="hours"
                        component="div"
                        className="text-red-500 text-[0.8vw]"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="duration"
                        className="w-full mb-[0.5vw] text-[1.1vw] font-semibold text-[#1f487c]"
                      >
                        Time Duration
                      </label>
                      {hours === "peak" ? (
                        <Field
                          id="duration"
                          name="duration"
                          type="text"
                          value="18 - 22"
                          disabled
                          className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                       text-[#1F487C] text-[1vw] h-[2.7vw] w-full rounded-[0.5vw] outline-none px-[1vw]"
                        />
                      ) : hours === "regular" ? (
                        <Field
                          as="select"
                          id="duration"
                          name="duration"
                          value={duration}
                          onChange={handleDurationChange}
                          className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                       text-[#1F487C] text-[1vw] h-[2.7vw] w-full rounded-[0.5vw] outline-none px-[1vw]"
                        >
                          <option value="" disabled>
                            Select Duration
                          </option>
                          <option value="8-10">08 - 10</option>
                          <option value="12-14">12 - 14</option>
                          <option value="14-17">14 - 17</option>
                        </Field>
                      ) : (
                        <Field
                          id="duration"
                          name="duration"
                          type="text"
                          value={duration}
                          disabled
                          className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                       text-[#1F487C] text-[1vw] h-[2.7vw] w-full rounded-[0.5vw] outline-none px-[1vw]"
                        />
                      )}
                      {required == true ? (
                        <div className="text-red-500 text-[0.8vw]">
                          hours & duration required
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div> */}
            </div>
            {/* )} */}
          </Form>
        )}
      </Formik>

      
    </div>
  );
};

export default Ad_Advertisement;
